import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControlsModule } from '@shared/form-controls/form-controls.module';
import { getMinBudgetValue, RetailMediaCampaignFormType } from '@rmn/forms/retail-media-campaign-form';
import { RetailMediaParametersAgreementComponent } from '../parameters/retail-media-parameters-agreement';
import {
    CampaignParametersNameComponent,
    CampaignParametersBudgetComponent,
    CampaignParametersAudienceSegmentsComponent
} from '@shared/campaign/components/parameters';
import { CampaignAudienceSegment } from '@core/campaigns';
import { PartnerInterface } from '@rmn/models/retail-media-partner.interface';
import { CampaignTermsComponent } from '@shared/campaign/components/campaign-terms/campaign-terms.component';

@Component({
    selector: 'rm-campaign-parameters-form',
    standalone: true,
    imports: [
        CommonModule,
        FormControlsModule,
        CampaignParametersNameComponent,
        CampaignParametersBudgetComponent,
        CampaignParametersAudienceSegmentsComponent,
        RetailMediaParametersAgreementComponent,
        CampaignTermsComponent
    ],
    templateUrl: './retail-media-campaign-parameters-form.component.html',
    styleUrls: ['./retail-media-campaign-parameters-form.component.scss']
})
export class RetailMediaCampaignParametersFormComponent {
    @Input()
    public form!: RetailMediaCampaignFormType;

    @Input()
    public audienceSegments!: CampaignAudienceSegment[];

    @Input()
    public partners!: PartnerInterface[];

    protected get minBudget(): number {
        return getMinBudgetValue(this.form);
    }
}
